/**
 * Investor-Portal Login (#1133) — separates Cookie, eigenes Layout.
 */
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useInvestorAuth } from '../../context/InvestorAuthContext';

export default function InvestorLogin() {
  const { login } = useInvestorAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
      const target = (location.state && location.state.from) || '/investor';
      navigate(target, { replace: true });
    } catch (e) {
      setErr(e.message || 'Login fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FC] px-4">
      <div className="w-full max-w-md bg-white rounded-xl border border-[#E5E7EB] p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-lg bg-[#338edc] flex items-center justify-center text-white font-bold">W</div>
          <div>
            <div className="text-sm font-semibold text-[#1A1A2E]">WeShip Investor-Portal</div>
            <div className="text-xs text-[#6B7280]">Plan vs. IST · Reporting</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3">
          <label className="block">
            <span className="text-xs text-[#4B5563] font-medium">E-Mail</span>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="mt-1 w-full px-3 py-2 rounded-lg border border-[#E5E7EB] text-sm focus:outline-none focus:border-[#338edc]"
            />
          </label>
          <label className="block">
            <span className="text-xs text-[#4B5563] font-medium">Passwort</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2 rounded-lg border border-[#E5E7EB] text-sm focus:outline-none focus:border-[#338edc]"
            />
          </label>

          {err && (
            <div className="text-xs text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
              {err}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            className="w-full bg-[#338edc] text-white text-sm font-medium rounded-lg py-2.5 hover:bg-[#2a7bc4] disabled:opacity-60"
          >
            {busy ? 'Anmelden…' : 'Anmelden'}
          </button>
        </form>

        <div className="mt-6 text-[11px] text-[#9CA3AF] text-center">
          Vertrauliche Finanz-Daten · Zugang nur für autorisierte Stakeholder
        </div>
      </div>
    </div>
  );
}
